module.exports = __webpack_public_path__ + "img/homepage_banner_outlined_2_extended.01e6bc4b.svg";